var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import padding from "../../global/padding";
export var StyledFeedItem = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  padding: ", ";\n  ", "\n  transition: background-color .24s;\n  border-bottom: 1px solid ", ";\n"], ["\n  position: relative;\n  padding: ", ";\n  ",
    "\n  transition: background-color .24s;\n  border-bottom: 1px solid ", ";\n"])), padding.tiny, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), padding.base);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.light;
});
var templateObject_1, templateObject_2;
